import ReactDOM from "react-dom";
import { useEffect } from "react";

const PLATFORMS = [
  { label: "Netflix", url: (t) => `https://www.netflix.com/search?q=${t}`, domain: "netflix.com" },
  { label: "Prime Video", url: (t) => `https://www.primevideo.com/search?phrase=${t}`, domain: "primevideo.com" },
  { label: "Max (HBO)", url: (t) => `https://play.max.com/search?q=${t}`, domain: "max.com" },
  { label: "Disney+", url: (t) => `https://www.disneyplus.com/search?q=${t}`, domain: "disneyplus.com" },
  { label: "Apple TV+", url: (t) => `https://tv.apple.com/search?term=${t}`, domain: "tv.apple.com" },
  { label: "YouTube", url: (t) => `https://www.youtube.com/results?search_query=${t}+trailer`, domain: "youtube.com" },
];

export default function Lightbox({ isOpen, imageSrc, title, onClose }) {
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
        };
        if (isOpen) {
            document.body.style.overflow = "hidden";
            window.addEventListener("keydown", handleEsc);
        }
        return () => {
            document.body.style.overflow = "unset";
            window.removeEventListener("keydown", handleEsc);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="lightbox-overlay" onClick={onClose}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                <button className="lightbox-close" onClick={onClose}>
                    &times;
                </button>
                <div className="lightbox-body">
                    <img src={imageSrc} alt="Lightbox preview" className="lightbox-image" />
                    {title && (
                        <div className="lightbox-links">
                            <span className="lightbox-links-label">WATCH ON</span>
                            <div className="lightbox-links-list">
                                {PLATFORMS.map((p) => (
                                    <a
                                        key={p.label}
                                        href={p.url(encodeURIComponent(title))}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="lightbox-link-btn"
                                        title={p.label}
                                    >
                                        <img
                                            src={`https://www.google.com/s2/favicons?domain=${p.domain}&sz=64`}
                                            alt=""
                                            width="20"
                                            height="20"
                                            loading="lazy"
                                            className="lightbox-link-logo"
                                        />
                                        <span className="lightbox-link-label">{p.label}</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>,
        document.body
    );
}